export default "__VITE_ASSET__BxzdI4FS__"